import { Col, DesignTokens, Row, Space, Title } from "melco-ui";
import { useEffect, useState } from "react";
import {
  parseAPIErrorResponse,
  ReportingMelcoMachineStatisticsModelsView,
} from "melco-shared-logic";
import { useValidateLogin } from "../../hooks/login/useValidateLogin";
import { DisplayErrors } from "../helper/DisplayErrors";
import MelcoAccountFlowLayout from "../layout/MelcoAccountFlowLayout";
import { useLogin } from "../../hooks/login/useLogin";
import { DisplayMachineStatusViewGroupsAndMachies } from "./DisplayMachineStatusViewGroupsAndMachines";
import { DisplayWrapper } from "../helper/reportingHelper";

type MachineStatusViewProps = {
  view?: ReportingMelcoMachineStatisticsModelsView;
  access_token: string;
  password: string;
  user_id: string;
};

const { spacings } = DesignTokens;

export const MachineStatusView: React.FC<MachineStatusViewProps> = ({
  view,
  access_token,
  password,
  user_id,
}) => {
  const validateLogin = useValidateLogin();
  const login = useLogin();
  const [viewDetail, setViewDetail] = useState(view);

  const [refLastUpdatedViewDateTime, setRefLastUpdatedViewDateTime] = useState(
    new Date()
  );
  const [errors, setErrors] = useState<any[]>();

  //Effect to check inactivity condition
  const checkValidToken = async () => {
    let validateLoginResponse = undefined;
    try {
      validateLoginResponse = await validateLogin({
        access_token: access_token,
      });
    } catch (error) {
      const apiErrors = await parseAPIErrorResponse(error);
      setErrors(apiErrors);
    } finally {
      return validateLoginResponse;
    }
  };

  const refreshLoginLogic = async () => {
    console.log("refreshLoginLogic");
    let loginResponse = undefined;
    try {
      loginResponse = await login({
        password: password,
        access_token,
        view_id: viewDetail?.id,
      });
    } catch (error) {
      const apiErrors = await parseAPIErrorResponse(error);
      setErrors(apiErrors);
    } finally {
      setViewDetail(loginResponse);
      return;
    }
  };

  const refreshLogin = async (updatedDate: any) => {
    console.log("refreshLogin");

    if (
      new Date(updatedDate).toISOString() >
      refLastUpdatedViewDateTime.toISOString()
    ) {
      refreshLoginLogic();
      setRefLastUpdatedViewDateTime(new Date(updatedDate));
    } else {
      console.log("Lesser");
    }
  };

  useEffect(() => {
    // Need to get latest data as if we reload the /view page, it goes through routing and takes old data
    refreshLoginLogic();

    const checkForReloadPage = async () => {
      console.log("checkForReloadPage");
      let validateLoginResponse = await checkValidToken();

      let updatedDate = validateLoginResponse?.updated_date ?? undefined;

      if (!updatedDate) {
        return null;
      }

      refreshLogin(updatedDate);
    };
    const interval = setInterval(checkForReloadPage, 5 * 60 * 1000); // Check every 5 min
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {errors && errors.length > 0 && (
        <MelcoAccountFlowLayout>
          <Space direction="vertical" size="xlarge">
            <>{<DisplayErrors errors={errors} />}</>
          </Space>
        </MelcoAccountFlowLayout>
      )}
      {!errors && (
        <DisplayWrapper>
          <Row gutter={[spacings.middle, spacings.middle]}>
            <Col xs={24} md={12} xl={12}>
              <div style={{ marginLeft: "15px" }}>
                <Title level={3}>{viewDetail?.name}</Title>
              </div>
            </Col>
          </Row>
          {viewDetail && (
            <DisplayMachineStatusViewGroupsAndMachies
              user_id={user_id}
              viewDetailObj={viewDetail}
            />
          )}
        </DisplayWrapper>
      )}
    </>
  );
};
